<template>

    <div class="hall-flex" :class="'hall-' + info.hallId">
        <div class="col-md-9 col-xs-12">
            <div class="hall is-small">
                <div class="display-hall">
                  <div class='lifted'> <!--:style='styleScreen'-->
                    <p>Экран</p>
                  </div>
                </div>
                <div class="full-hall">
                    <div 
                        v-for="row in rows" 
                        class="one-row-of-places"
                    >
                        <div class="row-number">{{row.row}} ряд</div>    
                        <div 
                            class="place one-place" 
                            :class="{active: isInArray(places[place]), 'is-loading': isLoading(places[place]), disabled: places[place].sold}" 
                            :style="{marginLeft: places[place].margin + 'em'}"
                            @click="want(places[place])" 
                            :data-item="[place]"
                            v-for="place in row.places"
                        >
                            {{places[place].place}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-3 col-xs-12 has-text-left">
            <h2 class="subtitle" style="margin-bottom: 0px;" @click="openFilm"><strong>{{ info.name }}</strong> </h2>
            <p style="font-size: 18px; font-style: oblique; "> {{info.datetime | moment("D MMMM HH:mm")}} </p>
               <!-- <img :src="info.smallPoster" alt="">-->
            <hr style="margin-top: 1px;">
            <div style="font-size: 18px">
                <p> Зал: <strong>{{info.hall}}</strong> </p>
                <p> Продолжительность: <strong>{{info.duration}} мин.</strong></p>
                <p> Возрастные ограничения: <strong>{{info.ageLimit}}+</strong> </p>
            </div>
            <hr>
            <h3 class="subtitle" style="margin-bottom: 0.5rem;">Выбранные места:</h3>
            <div class="tickets" v-if="added.length > 0">
                <ul style="font-size: 18px">
                    <li v-for="ticket in added.slice().reverse()" :key="ticket.id">
                        <font-awesome-icon icon="ticket-alt"/>
                        {{ places[ticket].row }} ряд - {{ places[ticket].place }} место
                        <!--<font-awesome-icon icon="close"/>-->
                    </li>
                </ul>
                <hr>
                <h3 class="subtitle has-text-right">Итого: {{sum}} <font-awesome-icon icon="ruble-sign"/> </h3>
                <div class="columns is-multiline tickets__button">
                    <div class="column is-half">
                        <button @click="cancel" class="button is-warning" :class="{ disabled: loading.length > 0 }">Очистить</button>
                    </div>
                    <div class="column is-half">
                        <button class="button is-success" :class="{ disabled: loading.length > 0 }" @click="buy">Купить</button>
                    </div>
                    <div class="column has-text-centered">
                        <button class="button is-info" v-if="!info.onlyBuy" :class="{ disabled: loading.length > 0 }" @click="order">Забронировать</button>
                    </div>
                </div>
            </div>
            <div class="notification is-warning" v-else><strong>Места не выбраны!</strong>
            </div>
            <!--<button class="button is-large is-success" @click="goback">Назад</button>-->
            <br>
            <h3 class="subtitle">Легенда</h3>
            <ul class="legend">
                <li><span class="place" style="margin:0; padding: 4px 12px; height: 28px; width: 31px;"></span> &mdash; Cвободные места.</li>
                <li><span class="place active" style="margin:0; padding: 4px 12px; height: 28px; width: 31px;"></span> &mdash; Выбранные вами.</li>
                <li><span class="place disabled" style="margin:0; padding: 4px 12px; height: 28px; width: 31px;"> </span> &mdash; Занятые места.</li>
            </ul>
        </div>
    </div>
</template>

<script>
    import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
    //import $ from 'jquery'
    import axios from 'axios'
    import { callbackify } from 'util';
    //import

    export default {
        name: "hall",
        data() {
            return {
                added: [],
                loading: [],
                sum: 0,
                id: null,
                rows: [],
                places: [],
                minX: 1000,
                maxX: 0,
                minY: 1000,
                maxY: 0,
                d: 0,
                token: 0,
                sale_id: 0,
                is_first: true,
                ticks : '',
                info: [],
                filmUrl: '',
                step: 100000,
                maxPlacesRow: 0, 
            }
        },
        computed: {
           styleScreen(){
               return {
                   top: 0,
                   left: (this.minX/this.d) +"%",
                   width: this.fullWidth() + "%",
                   height: '25px',
               }
           },
        },
        methods: {
            order () {
                this.ticks = '';
                if (this.loading.length>0) return false;
                for (var i = 0; i < this.added.length; i++)
                {
                    this.ticks = this.ticks+this.places[this.added[i]].row+' ряд - '+this.places[this.added[i]].place+' место <br>';
                }
                console.log("Бронирование");
                this.$swal({
                    title: 'Вы выбрали места:',
                    html: this.ticks,
                    type: 'success',
                    showCancelButton: true,
                    confirmButtonColor: '#23d160',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Да, забронировать',
                    cancelButtonText: 'Изменить'
                }).then((result) => {
                    if (result.value) {
                        // Бронирование
                        axios.post(urls[6], {
                            places: this.added,
                            saleId: this.sale_id,
                            type: "sale",
                            token: this.token
                        }).then(response => {
                            //this.$swal.closeModal();
                            if (!response.data){
                                this.$swal({
                                    title: 'Ошибка',
                                    text: 'Ошибка при попытке оформить бронь. Попробуйте позже.',
                                });
                                this.loadingRemove(place);
                                this.is_first = true;
                            }
                            window.location = response.request.responseURL;
                        }).catch(error => {
                                // handle error
                                console.log(error);
                        });
                        //window.location.replace(urls[5]);
                        //this.$router.push({ name: "terminalBuy", params: { places: this.added, token: this.token, sale_id: this.sale_id }});
                    }

                });
            },
            buy () {
                this.ticks = '';
                if (this.loading.length>0) return false;
                for (var i = 0; i < this.added.length; i++) 
                {
                    this.ticks = this.ticks+this.places[this.added[i]].row+' ряд - '+this.places[this.added[i]].place+' место <br>';
                }
                
                console.log("Оплата");
                this.$swal({
                  title: 'Вы выбрали места:',
                  html: this.ticks,
                  type: 'success',
                  showCancelButton: true,
                  confirmButtonColor: '#23d160',
                  cancelButtonColor: '#d33',
                  confirmButtonText: 'Да, перейти к оплате',
                  cancelButtonText: 'Изменить'
                }).then((result) => {
                  if (result.value) {
                    axios.post(urls[5], {
                        saleId: this.sale_id,
                        type: "sale",
                        token: this.token                        
                    }).then(response => {
                        //this.$swal.closeModal();                        
                        if (!response.data){
                            this.$swal({
                                    title: 'Ошибка',
                                    text: 'Ошибка при попытке оформить продажу. Попробуйте позже.',
                            });
                            this.loadingRemove(place);
                            this.is_first = true;
                        }
                        window.location = response.request.responseURL;
                        // console.log(response);
                        // console.log(response.data);
                        // console.log(response.status);
                        // console.log(response.statusText);
                        // console.log(response.headers);
                        // console.log(response.config);
                        // console.log(response.request.responseURL);
                    }).catch(error => {
                        // handle error
                        console.log(error);
                    });
                    //window.location.replace(urls[5]);
                    //this.$router.push({ name: "terminalBuy", params: { places: this.added, token: this.token, sale_id: this.sale_id }});
                  }
                });
            },
            openFilm() {
                window.location.replace(this.filmUrl);
            },
            removeSale (){
                axios.post(urls[3], {
                        places: this.added,
                        type: "sale",
                        token: this.token,
                }).then(response => {
                    if (response.status == 200){
                        this.$swal.closeModal();
                        this.added = [];
                        this.token = 0;
                        this.sum = 0;
                        this.is_first = true;
                    }
                })
                .catch(e => {
                    console.log(e);
                });
            },

            cancel(){
                if (this.loading.length>0) return false;
                this.$swal({
                    title: 'Ожидайте',
                    //timer: this.added.length * 800,
                    showConfirmButton: false,
                    onOpen: () => {
                        this.$swal.showLoading()
                    }
                });
                this.removeSale();
                //this.$swal.closeModal();
                this.token = 0;
                
            },
            isInArray(place) {
                // проверяем что элемент в списке
                return this.added.includes(place.id)? true: false;
            },
            isLoading(place) {
                return this.loading.includes(place.id)? true: false;
            },
            placeRemove(place){
                var i = this.added.length;
                while(i--){
                    if(this.added[i] == place.id){
                        this.added.splice(i, 1);
                        this.sum -= place.price;
                    }
                }
                if (this.added.length==0){
                    this.token = 0;
                    this.is_first = true;
                }
            },
            loadingRemove(place){
                var i = this.loading.length;
                while(i--){
                    if(this.loading[i] == place.id){
                        this.loading.splice(i, 1);
                    }
                }
            },
            want(place){
                if (place.sold) return false;
                if(typeof place == 'undefined'){
                    return 0;
                }
                if(this.added.includes(place.id)){
                    this.loading.push(place.id);
                    // удаляем элемент
                    axios.post(urls[2], {
                        place_id: place.id,
                        token: this.token
                    })
                    .then(response => {
                        this.loadingRemove(place);
                        if (response.status == 200){
                            this.placeRemove(place);
                            this.info.onlyBuy = !response.data.order;
                        }
                    })
                    .catch(e => {
                        console.log(e);
                    });

                } else {
                    // добавляем элемент в заказ
                    if (!this.is_first && (this.added.length == 0)){
                        this.$swal({
                            title: 'Ожидайте',
                            timer: 1000,
                            showConfirmButton: false,
                            onOpen: () => {
                                this.$swal.showLoading()
                            }
                        });
                        return;
                    }
                    this.is_first = false;
                    this.loading.push(place.id);
                    axios.post(urls[1], {
                        place_id: place.id,
                        token: this.token,
                        performance_id: show
                    })
                    .then(response => {
                        this.$swal.closeModal();
                        if (response.data){
                            //console.log(response);
                            this.loadingRemove(place);
                            this.token = response.data.token; 
                            this.added.push(place.id);
                            this.sum += place.price;
                            this.sale_id = response.data.saleId;
                            this.info.onlyBuy = !response.data.order;
                        } else {
                            this.$swal({
                                    title: 'Ошибка',
                                    text: 'Ошибка при добавлении места.',
                            });
                            this.loadingRemove(place);
                            this.is_first = true;
                        }
                    })
                    .catch(e => {
                        if(e.hasOwnProperty('code')){
                            if(e.code == 8){
                                window.reload();
                            }
                        }
                        console.log(e);
                    });
                }
            },
            fullWidth(){
                // return ((this.maxX-this.minX+35)/this.d - this.minX/this.d);
                return ((this.maxX-this.minX-20)/this.d - this.minX/this.d);
            },
            placePos(place){
                return {
                    top: this.computedY(place) + '%',
                    left: (this.computedX(place) - (35/this.d)) + '%',
                    width: '35px',//(35/this.d) + '%',
                    height: '35px',//(35/this.d) + '%',
                }
            },
            computedY(place){
                //console.log('плейс ' + place.Y);
                //console.log('d ' + this.d);
                       //(maxY:0) - (place.Y) + (minY:1000)/d:0 + (35/d:0)
                return ((this.maxY - place.Y + this.minY)/this.d + (35/this.d));
            },
            computedX(place){
                let d = this.maxX/this.fullWidth()
                return 2*(this.minX/d) + (this.maxX - place.X)/d;
            },
            getFilmInfo(){
                axios.post(urls[0], {
                    id: this.id,
                    type: "getinfo"
                })
                .then(response => {
                    if(response.data){
                        this.info = response.data;
                    }
                })
                .catch(e => {
                    console.log(e);
                });
            }
            },
            mounted(){
                this.$swal({
                    title: 'Ожидайте',
                    //timer: 1000,
                    showConfirmButton: false,
                    onOpen: () => {
                        this.$swal.showLoading()
                    }
                });
                this.filmUrl = urls[4];
                this.id = show;
                this.getFilmInfo();
                var ther = this;
                console.log(ther);
                /*
                this.$router.beforeEach((to, from, next) => {
                    //console.log("testroute");
                    //console.log(to.path);
                    this.$root.$emit('redir', to.path)
                    next();
                })
                this.$root.$once('goBack', function() {
                    ther.removeSale();
                    //console.log(ther.$router.path);
                    //ther.$router.go(-1);

                });
                
                this.$root.$once('goHome', function() {//.$root
                    //console.log("test2");
                    ther.removeSale();
                });
                */
                // $('.hall').height($('.hero-body').height());
                

                axios.post(urls[0], {
                    id: this.id
                })
                    .then(response => {
                        if(response.data){
                            this.places =  response.data.hall;

                            for(var el in this.places){                                
                                var row = this.places[el].row;
                                if(!(row in this.rows)){
                                    this.rows[row] = this.places[el];
                                }                                    
                                this.minX = Math.min(this.minX, this.places[el].X);
                                this.minY = Math.min(this.minY, this.places[el].Y);

                                this.maxX = Math.max(this.maxX, this.places[el].X);
                                this.maxY = Math.max(this.maxY, this.places[el].Y);

                                this.d = Math.max(this.d, Math.max(this.places[el].X, this.places[el].Y)/100);
                                
                                if(this.rows[row]["places"] === undefined){
                                    this.rows[row]["places"] = [];
                                }
                                
                                this.rows[row].places.push(el);
                                this.maxPlacesRow = Math.max(this.maxPlacesRow, this.rows[row].places.length);
                                if (this.rows[row].places.length > 1){
                                  let current = this.rows[row].places[this.rows[row].places.length - 1];
                                  let prev = this.rows[row].places[this.rows[row].places.length - 2];
                                  this.step = Math.min(this.step, Math.abs(this.places[current].X - this.places[prev].X));
                                }
                            }
                            
                            this.rows.splice(0,1);
                            var self = this;
                            this.rows[this.rows.length-1].places.sort(function(a, b){
                              return self.places[a].number - self.places[b].number;
                            });

                            for(let i = 0; i < this.rows.length; i++){
                              for(let j = 0; j< this.rows[i].places.length; j++){
                                let place = this.places[this.rows[i].places[j]];
                                place.X = this.maxX - place.X + this.minX;
                                if(j == 0 && place.X > this.minX){
                                  let calc = Math.abs(place.X - this.minX);
                                  calc = calc % 5 != 0 ? (calc / 100).toFixed(1)*100 : calc;
                                  place.margin = calc/this.step * 2.5;
                                }
                                if(j > 0){
                                  let prev = this.places[this.rows[i].places[j - 1]];
                                  if(place.X - prev.X > this.step + 5){
                                    place.margin = (Math.abs(place.X - prev.X))/this.step * 2.5;
                                  }
                                }
                              }
                            }

                            this.$nextTick(function () {
                              $('.lifted').css('width',((this.maxPlacesRow * 2) + ((this.maxPlacesRow - 1) * 0.5))+'em');
                              let dataHall = function(){
                                const bodyHall = $('.hall-flex > div:first-child');
                                let widthBodyHall = bodyHall.width();
                                let widthHall = $('.full-hall').width();
                                let diff = widthBodyHall / widthHall;
                                let fontSize = diff;
                                fontSize = fontSize > 150 ? 150 : fontSize;
                                bodyHall.css('font-size', fontSize + '%');
                                let renderHall = function() {
                                  let currentWidthBodyHall = bodyHall.width(); 
                                  let diffPercent = (1 - widthBodyHall / currentWidthBodyHall);
                                  let currentDiff = diff + (diff * diffPercent);
                                  let currentFontSize = currentDiff > 150 ? 150 : currentDiff;
                                  bodyHall.css('font-size', currentFontSize + '%');
                                };
                                window.addEventListener('resize', renderHall, false);
                              };
                              setTimeout(dataHall, 1000);
                            });
                        }
                    })
                    .catch(e => {
                        console.log(e);
                    })
                this.$swal.closeModal();
            },
        components: {
            FontAwesomeIcon,
            
        }
    }
</script>


// WEBPACK FOOTER //
// hall.vue?4e32849c